import { App, Flex } from "antd";
import Search from "antd/es/input/Search";
import { FC } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { getApiError, postSchedulerMovePointsToRoute } from "tm-shared/api";
import { Route } from "tm-shared/types";

import { useAsyncAction, useDebounce } from "@/hooks";
import { useAppSelector } from "@/hooks/redux";
import {
    RouteEditorModal,
    RouteEditorModalPayloads,
} from "@/pages/SV/RouteManagement/RouteEditor/RouteEditor.types";
import { BaseModal } from "@/shared/ui/BaseModal";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledCard } from "./Styled";

interface MoveScheduleModalProps {
    onClose: () => void;
    payload: RouteEditorModalPayloads[RouteEditorModal.MoveSchedule];
    onApprove: () => Promise<void>;
}

export const MoveScheduleModal: FC<MoveScheduleModalProps> = ({
    onClose,
    payload,
    onApprove,
}) => {
    const { notification } = App.useApp();

    const [search, setSearch] = useState("");

    const [selectedItem, setSelectedItem] = useState<Route | null>(null);
    const { routeList } = useAppSelector((state) => state.manager);
    const { routeId } = useParams();

    const quernRouteId = Object.values(routeList).find(
        (item) => item.uuid === routeId,
    )?.uuid;

    const debouncedSearch = useDebounce(search, 300);

    const availableRoutes = Object.values(routeList).filter((item) => {
        const normalizeSearch = debouncedSearch.toLowerCase().trim();
        const normalizeName = item.name.toLowerCase();

        return (
            item.uuid !== quernRouteId &&
            normalizeName.includes(normalizeSearch)
        );
    });

    const { currentRouteId, pointIds } = payload;

    const [handleMove, moveLoading] = useAsyncAction(async () => {
        if (!selectedItem) return;

        try {
            await postSchedulerMovePointsToRoute({
                pointIds,
                oldRouteId: currentRouteId,
                newRouteId: selectedItem?.uuid,
            }),
                onClose();
        } catch (err) {
            console.log(err);
            const { displayMessage } = getApiError(err);
            notification.error({
                title: "Не вдалося перемістити ТТ",
                description: displayMessage,
            });
        }

        await onApprove();
    });

    return (
        <BaseModal
            open
            onClose={onClose}
            centered
            title={"Перемістити ТТ"}
            confirmText="Перемістити"
            onConfirm={handleMove}
            cancelText="Скасувати"
            onCancel={onClose}
            confirmDisabled={!selectedItem}
            confirmLoading={moveLoading}
        >
            <PrimaryText>Оберіть один маршрут для переміщення</PrimaryText>

            <Search
                allowClear
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <Flex
                vertical
                gap={8}
                style={{ overflow: "auto", minHeight: 0, height: "100%" }}
            >
                {availableRoutes.map((item) => (
                    <StyledCard
                        key={item.uuid}
                        $selected={selectedItem?.uuid === item.uuid}
                        onClick={() => setSelectedItem(item)}
                    >
                        <PrimaryText fontSize={16} fontWeight="500">
                            {item.name}
                        </PrimaryText>

                        <Flex gap={4}>
                            <SecondaryText fontSize={12}>
                                Кількість ТТ:
                            </SecondaryText>

                            <PrimaryText fontSize={12}>
                                {item?.pointCount ?? "-"}
                            </PrimaryText>
                        </Flex>

                        <Flex gap={4}>
                            <SecondaryText fontSize={12}>ТА:</SecondaryText>

                            <PrimaryText fontSize={12}>
                                {item?.agentInfo
                                    ? `${item.agentInfo.fullName}`
                                    : "-"}
                            </PrimaryText>
                        </Flex>
                    </StyledCard>
                ))}
            </Flex>
        </BaseModal>
    );
};
